import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { NavMarker } from 'react-rhumb';
import { Integration } from 'signup-constants/Integration';
import { Step } from 'signup-constants/Step';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { useIsSU0004Variation } from '../hooks/useIsSU0004Variation';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { isIntegration } from '../utils/isIntegration';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { EmailDataInput } from './EmailDataInput';
import { GoogleWorkspaceEmailSignup } from './GoogleWorkspaceEmailSignup';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { LandingPageTitle } from './LandingPageTitle';
import { isFlow } from '../utils/isFlow';
import { Flow } from 'signup-constants/Flow';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import imageUrls from '../images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const isGoogleWorkspaceAppIntegration = isIntegration(Integration.GoogleWorkspaceApp);
  const isIntegrationsFlow = isFlow(Flow.Integrations);
  const {
    shouldShowTosOnLandingPage: shouldShowTermsOfService,
    shouldShowSignInButton,
    emailSignupEnabled
  } = getFlowConfig();
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    layoutType
  } = useLayoutTemplate();
  const isSU0004Variation = useIsSU0004Variation();
  useExperiment(ExperimentKeys.ACQ0177, TrackWhen.enrolled);
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const isGoogleWorkspaceSignupFlow = isGoogleWorkspaceAppIntegration && isIntegrationsFlow;
  const Footer = () => {
    if (isInstanceOfSignupEmbedder) {
      return /*#__PURE__*/_jsx(Text, {
        as: "div",
        marginBlock: "300",
        textAlign: "center",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(PrivacyBanner, {})
      });
    }
    if (isTrellisThemeEnabled) {
      return /*#__PURE__*/_jsxs(View, {
        marginInline: "auto",
        maxInlineSize: "420px",
        paddingInline: "500",
        children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      "data-test-id": `${stepKey}-container`,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [isSU0004Variation && /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(Image, {
            alt: "HubSpot",
            "data-test-id": "su0004-wordmark",
            height: "40px",
            src: imageUrls.trellisLogo,
            width: "140px"
          })
        }), /*#__PURE__*/_jsx(LandingPageTitle, {
          isMobile: isMobile,
          isSU0004Variation: isSU0004Variation
        }), /*#__PURE__*/_jsxs(LayoutTemplateContentContainer, {
          $layoutType: layoutType,
          $shouldRestrictWidth: true,
          children: [/*#__PURE__*/_jsx(OAuthSignupSection, {
            shouldShowSeperator: !isGoogleWorkspaceSignupFlow && emailSignupEnabled
          }), isGoogleWorkspaceSignupFlow ? /*#__PURE__*/_jsx(GoogleWorkspaceEmailSignup, {
            emailSignupEnabled: emailSignupEnabled
          }) : emailSignupEnabled && /*#__PURE__*/_jsx(EmailDataInput, {
            isSU0004Variation: isSU0004Variation
          }), /*#__PURE__*/_jsx(Footer, {}), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "500",
            textAlign: "center",
            children: shouldShowSignInButton && /*#__PURE__*/_jsx(HaveAnAccountLink, {})
          })]
        })]
      })
    })
  });
};
export default LandingPageView;